import { getTranslatedKPINameV2 } from 'helpers/translateHelper';

export const splitSelectedSignals = (timeseriesKeyString) => {
    if (!timeseriesKeyString) {
        return [];
    }
    return timeseriesKeyString.split(',').map(key => key.trim());
};

export const formatKpiLabel = (kpi) => {
    const name = getTranslatedKPINameV2(kpi) || '';
    return name;
};
